import(/* webpackMode: "eager" */ "/tmp/build_345839d7/apps/sales-pilot-sites/src/app/global-error.tsx");
